export const PARTNER_TYPES = {
  PRO: 'PRO',
  TEST: 'TEST',
  PERSONAL: 'PERSONAL',
} as const;

export type PartnerTypes = keyof typeof PARTNER_TYPES;

export const PARTNER_STATUS = {
  PENDING: 'PENDING',
  BLOCKED: 'BLOCKED',
  VALIDATED: 'VALIDATED',
} as const;

export type PartnerStatus = typeof PARTNER_STATUS;

export const PARTNER_PROFILE = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
};

export const PARTNER_ERP_SYNCHRONISATION_STATE = {
  SYNCHRONISED: 'SYNCHRONISED',
  NOT_SYNCHRONISED: 'NOT_SYNCHRONISED',
};

export const PARTNER_ACCOUNT_STATUS = {
  COMPLETED: 'COMPLETED',
  NOT_COMPLETED: 'NOT_COMPLETED',
};

export const PARTNER_HIERARCHY_TYPE = {
  COMPANY: 'COMPANY',
  ORGANIZATION: 'ORGANIZATION',
} as const;

export type PartnerHierarchyType =
  (typeof PARTNER_HIERARCHY_TYPE)[keyof typeof PARTNER_HIERARCHY_TYPE];

export const TREE_BRANCH = '└';

export const isOrganization = (
  type: PartnerHierarchyType | undefined
): boolean => type === PARTNER_HIERARCHY_TYPE.ORGANIZATION;

export const isCompany = (type: PartnerHierarchyType | undefined): boolean =>
  type === PARTNER_HIERARCHY_TYPE.COMPANY;
